<template>
  <div>
    <v-card>
      <v-img max-height="450" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-lg-8" color="rgba(0, 0, 0, 0)">
          <v-app-bar-nav-icon
            @click="showSlidebar"
            color="white"
          ></v-app-bar-nav-icon>

          <v-spacer></v-spacer>

          <v-btn color="white" @click="signout()" icon>
            <v-icon>mdi-export</v-icon>
          </v-btn>
        </v-app-bar>

        <v-card-title class="white--text mt-sm-5 mt-xs-5 mt-lg-8">
          <div class="ml-lg-10">
            <p class="ml-3 mb-0 pb-lg-4 pb-xl-4 pb-sm-0 pb-xs-0 text-home-name">
              {{ res_userInfoMeta.meta.nama }}
            </p>
            <p class="ml-3 mt-3 pt-0 text-home-sub">
              {{ res_userInfo.noa }}
            </p>
          </div>
          <v-spacer></v-spacer>

          <v-avatar size="70" class="avatar-home mr-lg-10">
            <img
              contain
              aspect-ratio="2"
              alt="user"
              :src="res_userInfo.image_url"
            />
          </v-avatar>
        </v-card-title>
      </v-img>
    </v-card>
    <v-card class="mx-5" style="margin-top: -0.5rem; border-radius: 1rem;">
      <div
        class="mx-5 pb-4 d-flex justify-space-around flex-wrap align-content-center"
      >
        <div v-for="(item, j) in res_authMenu" :key="j">
          <div class="text-center">
            <v-btn
              class="ma-3 mb-1 pa-2"
              fab
              dark
              @click="goToPage(item.path)"
              small
              color="#ff7200"
            >
              <v-img
                v-if="item.name == 'SHU'"
                width="5"
                src="@/assets/icon/bills-of-dollars.png"
              ></v-img>
              <v-img
                v-else-if="item.name == 'Simpanan'"
                width="5"
                src="@/assets/icon/wallet.png"
              ></v-img>
              <v-img
                v-else-if="item.name == 'Pinjaman'"
                width="5"
                src="@/assets/icon/incomes.png"
              ></v-img>
              <v-icon v-else color="white">
                {{ item.icon }}
              </v-icon>
            </v-btn>
            <p class="text-orange-sm mb-1">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </v-card>
    <div v-if="!isPageReady">
      <v-card-title class="mb-0 pb-0">Berita: </v-card-title>
      <div
        class="mx-3 w-100 d-flex justify-center"
        outlined
        min-height="600px"
        v-if="res_news.data.length < 1"
      >
        <div class="not-found text-center d-flex flex-column  justify-center">
          <img
            src="@/assets/img/employee_not_found.png"
            class="img-not-found-center"
            alt="Data Not Found"
          />
          <p class="text-bold-xl my-0 py-0">Tidak Ada Berita Terbaru</p>
        </div>
      </div>
      <div v-else>
        <v-container class="mt-0 pt-0">
          <div class="d-flex flex-wrap">
            <div v-for="(item, i) in res_news.data" :key="i" class="w-100">
              <v-card
                :color="item.color"
                min-width="300"
                max-width="300"
                height="500"
                class="ma-2"
              >
                <v-img
                  :src="item.banner_image_url"
                  contain
                  min-height="200px"
                  max-height="300px"
                ></v-img>
                <v-card-title
                  class="headline"
                  v-text="item.title"
                ></v-card-title>

                <v-card-subtitle
                  v-html="item.content_preview"
                ></v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="deep-purple lighten-2"
                    @click="goToDetail(item)"
                    text
                  >
                    Lihat Detail
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </v-container>
        <v-pagination
          class=""
          :total-visible="4"
          v-model="pages"
          :length="res_news.meta.total_page"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const loginData = createNamespacedHelpers("login");
const system = createNamespacedHelpers("system");
const news = createNamespacedHelpers("news");
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  data() {
    return {
      pages: 1,
      totalPage: 0,
      url: process.env.VUE_APP_URL
    };
  },
  mounted() {
    this.$store.dispatch("login/getUserInfo");
    this.$store.dispatch("system/getMenuByAuth");
    this.$store.dispatch("news/getNews");
    this.pages = this.page;
  },
  computed: {
    ...news.mapState(["res_news", "page"]),
    ...loginData.mapState(["res_userInfo", "res_userInfoMeta"]),
    ...system.mapState(["miniNav", "res_authMenu"]),
    isPageReady() {
      return this.res_news.length > 0;
    }
  },
  watch: {
    pages(val) {
      this.$store.commit("news/SET_PAGINATION", val);
      this.$store.dispatch("news/getNews");
    }
  },
  methods: {
    goToDetail(val) {
      this.$store.commit("news/SET_IDNEWS", val.id);
      this.$router.push("/" + val.slug);
    },
    goToPage(val) {
      this.$router.push(val);
    },
    showSlidebar() {
      this.$store.commit("system/SET_MINI", !this.miniNav);
    },
    signout() {
      Cookies.remove("token");
      Cookies.remove("userdata_login");
      this.$router.go();
    }
  }
};
</script>
<style scoped></style>
